var React = require('react');

function ArrowCircleLightInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"16","cy":"16","r":"15.5","stroke":"white","key":0}),React.createElement("path",{"d":"M13 10L19 16L13 22","stroke":"white","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

ArrowCircleLightInline.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = ArrowCircleLightInline;

ArrowCircleLightInline.default = ArrowCircleLightInline;
